import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/GenZ_Logo.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const FeedHeader = ({ onLogout, firstName, lastName, username }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  let displayName = "User";
  if (firstName || lastName) {
    displayName = `${firstName} ${lastName}`.trim();
  } else if (username) {
    displayName = username;
  }

  return (
    <header className="fixed top-0 left-0 w-full bg-white border-b z-50">
      <div className="flex items-center justify-between max-w-6xl mx-auto px-6 py-2.5">
        {/* Logo */}
        <img src={logo} alt="Logo" className="h-9 w-9" />

        {/* Search Bar */}
        <div className="flex-1 mx-8">
          <input
            type="text"
            placeholder="Search"
            className="w-full rounded-md border px-4 py-2 bg-gray-100 text-base focus:outline-none"
          />
        </div>

        {/* Seller Dashboard */}
        <a
          href="/sellerdashboard"
          className="flex items-center text-[#3B71FE] mr-6 text-lg font-semibold"
        >
          <img src="/header/SellerHeaderIcon.svg" alt="Seller" className="h-6 w-6 mr-2" />
          <span>Seller Dashboard</span>
        </a>

        {/* Profile Dropdown */}
        <div className="relative flex items-center">
          <img
            src="/brandIconPick.svg"
            alt="Profile"
            className="h-9 w-9 rounded-full object-cover bg-gray-200 border border-gray-300"
          />
          <span className="ml-3 text-lg font-semibold">{displayName}</span>
          <KeyboardArrowDownIcon
            className="ml-2 cursor-pointer text-2xl"
            onClick={() => setMenuOpen((open) => !open)}
            fontSize="medium"
          />
          {menuOpen && (
            <div className="absolute left-[-30px] top-full z-50 mt-2 w-48 rounded-lg border border-gray-200 bg-white shadow-sm">
              <div className="py-1">
                <button
                  onClick={() => navigate("/buyerprofile")}
                  className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              >
                Profile
                </button>
              <button
                onClick={onLogout}
                  className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              >
                Log out
              </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default FeedHeader; 